module.exports = __webpack_public_path__ + "img/BILDERAMME MEDIA.6348f7f8.png";